function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import utils from "common/utils";
import asset_utils from "common/asset_utils";
import AssetWrapper from "./AssetWrapper";
import counterpart from "counterpart";
import PropTypes from "prop-types";
import { Popover } from "bitshares-ui-style-guide";
import { ChainStore, FetchChainObjects } from "bitsharesjs";
import GatewayStore from "../../stores/GatewayStore";
import { getAssetAndGateway } from "../../lib/common/gatewayUtils";
import { Icon, Tooltip } from "bitshares-ui-style-guide";

class AssetName extends React.Component {
  static propTypes = {
    replace: PropTypes.bool.isRequired,
    dataPlace: PropTypes.string.isRequired
  };
  static defaultProps = {
    replace: true,
    noPrefix: false,
    noTip: false,
    dataPlace: "bottom"
  };

  constructor(props) {
    super(props);
    this.state = {
      assetIssuerName: null
    };

    this._load();
  }

  shouldComponentUpdate(np, ns) {
    return this.props.replace !== np.replace || this.props.asset !== np.asset || this.props.noPrefix !== np.noPrefix || this.props.noTip !== np.noTip || this.props.dataPlace !== np.dataPlace || this.state.assetIssuerName !== ns.assetIssuerName;
  }

  _load() {
    // cache asset issuer name
    if (!this.state.assetIssuerName && this.props.asset && this.props.asset.get) {
      FetchChainObjects(ChainStore.getAccountName, [this.props.asset.get("issuer")]).then(result => {
        if (this._isMounted) {
          // re-render, ChainStore cache now has the object
          this.setState({
            assetIssuerName: result[0]
          });
        }
      });
    }
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentDidUpdate() {
    this._load();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    let {
      replace,
      asset,
      noPrefix,
      customClass,
      noTip
    } = this.props;
    if (!asset) return null;
    const name = asset.get("symbol");
    const assetIssuerName = this.state.assetIssuerName;
    const isBitAsset = asset.has("bitasset");
    const isPredMarket = isBitAsset && asset.getIn(["bitasset", "is_prediction_market"]);
    let {
      name: replacedName,
      prefix
    } = utils.replaceName(asset);
    const hasBitPrefix = prefix === "bit";
    let includeBitAssetDescription = isBitAsset && !isPredMarket && hasBitPrefix;

    if (replace && replacedName !== name || isBitAsset) {
      let desc = asset_utils.parseDescription(asset.getIn(["options", "description"]));
      let realPrefix = name.split(".");
      realPrefix = realPrefix.length > 1 ? realPrefix[0] : null;
      if (realPrefix) realPrefix += ".";
      let optional = "";

      try {
        optional = realPrefix || includeBitAssetDescription ? counterpart.translate("gateway.assets." + (hasBitPrefix ? "bit" : realPrefix.replace(".", "").toLowerCase()), {
          asset: name,
          backed: includeBitAssetDescription ? desc.main : replacedName
        }) : "";
      } catch (e) {}

      if (isBitAsset && name === "CNY") {
        optional = optional + " " + counterpart.translate("gateway.assets.bitcny");
      }

      const upperCasePrefix = prefix && prefix === "bit" ? prefix : !!prefix ? prefix.toUpperCase() : prefix;
      let assetDiv = /*#__PURE__*/React.createElement("div", {
        className: "inline-block" + (this.props.noTip ? "" : " tooltip") + (customClass ? " " + customClass : "")
      }, /*#__PURE__*/React.createElement("span", {
        className: "asset-prefix-replaced"
      }, prefix), /*#__PURE__*/React.createElement("span", null, replacedName));

      if (!!noTip) {
        return assetDiv;
      } else {
        let title = (upperCasePrefix || "") + replacedName.toUpperCase();
        let popoverContent = /*#__PURE__*/React.createElement("div", {
          style: {
            maxWidth: "25rem"
          }
        }, desc.short ? desc.short : desc.main || "", optional !== "" && /*#__PURE__*/React.createElement("br", null), optional !== "" && /*#__PURE__*/React.createElement("br", null), optional, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), assetIssuerName && counterpart.translate("explorer.assets.issuer") + ": " + assetIssuerName);
        return /*#__PURE__*/React.createElement(Popover, {
          placement: this.props.dataPlace,
          content: popoverContent,
          title: title,
          mouseEnterDelay: 0.5
        }, assetDiv);
      }
    } else {
      let assetDiv = /*#__PURE__*/React.createElement("span", {
        className: customClass ? customClass : null
      }, /*#__PURE__*/React.createElement("span", {
        className: !noPrefix ? "asset-prefix-replaced" : ""
      }, !noPrefix ? prefix : null), /*#__PURE__*/React.createElement("span", null, replacedName));

      if (!!noTip) {
        return assetDiv;
      } else {
        let desc = null;

        if (replacedName == "BTS") {
          desc = {
            main: counterpart.translate("assets.BTS")
          };
        } else {
          desc = asset_utils.parseDescription(asset.getIn(["options", "description"]));
        }

        let title = (prefix || "") + replacedName.toUpperCase();
        let popoverContent = /*#__PURE__*/React.createElement("div", {
          style: {
            maxWidth: "25rem"
          }
        }, desc.short ? desc.short : desc.main || "", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), assetIssuerName && counterpart.translate("explorer.assets.issuer") + ": " + assetIssuerName);
        return /*#__PURE__*/React.createElement(Popover, {
          placement: this.props.dataPlace,
          content: popoverContent,
          title: title,
          mouseEnterDelay: 0.5
        }, assetDiv);
      }
    }
  }

}

AssetName = AssetWrapper(AssetName);
export default class AssetNameWrapper extends React.Component {
  render() {
    const gatewaySplit = getAssetAndGateway(this.props.name);
    let postfix = undefined;

    if (!!gatewaySplit && !!gatewaySplit.selectedGateway) {
      const onChainConfig = GatewayStore.getOnChainConfig(getAssetAndGateway(this.props.name).selectedGateway);
      const isDisabledGatewayAsset = !!onChainConfig && !onChainConfig.enabled;
      postfix = isDisabledGatewayAsset && /*#__PURE__*/React.createElement(Tooltip, {
        placement: "topLeft",
        title: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: counterpart.translate("external_service_provider.disabled_asset_1") + ". "
          }
        }), /*#__PURE__*/React.createElement("span", null, onChainConfig.comment), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, counterpart.translate("external_service_provider.disabled_asset_2")))
      }, "\xA0", /*#__PURE__*/React.createElement(Icon, {
        type: "warning"
      }));
    }

    let warning = undefined;

    if (GatewayStore.isAssetBlacklisted(this.props.name)) {
      warning = /*#__PURE__*/React.createElement(Tooltip, {
        placement: "topLeft",
        title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, counterpart.translate("explorer.assets.blacklisted")))
      }, "\xA0", /*#__PURE__*/React.createElement(Icon, {
        style: {
          color: "white"
        },
        type: "warning"
      }));
    }

    return !this.props.name ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AssetName, _extends({}, this.props, {
      asset: this.props.name
    })), postfix, warning);
  }

}